import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Import gallery images
import plato1 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.29.44 PM.jpeg';
import plato2 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.29.44 PM (1).jpeg';
import plato3 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.29.44 PM (2).jpeg';
import plato4 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.29.44 PM (3).jpeg';
import ambiente1 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.30.11 PM.jpeg';
import ambiente2 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.30.12 PM.jpeg';
import ambiente3 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.30.12 PM (1).jpeg';
import plato5 from '../assets/images/Platos/WhatsApp Image 2025-04-14 at 6.30.44 PM.jpeg';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      id: 1,
      src: plato1,
      alt: 'Parrillada de mariscos servida en mesa',
      category: 'Platos',
    },
    {
      id: 2,
      src: ambiente1,
      alt: 'Vista del restaurante al atardecer',
      category: 'Ambiente',
    },
    {
      id: 3,
      src: plato2,
      alt: 'Ceviche fresco con limón y cilantro',
      category: 'Platos',
    },
    {
      id: 4,
      src: plato3,
      alt: 'Cóctel de camarones con salsa especial',
      category: 'Platos',
    },
    {
      id: 5,
      src: ambiente2,
      alt: 'Terraza con vista al mar',
      category: 'Ambiente',
    },
    {
      id: 6,
      src: plato4,
      alt: 'Selección de pescados frescos del día',
      category: 'Platos',
    },
    {
      id: 7,
      src: plato5,
      alt: 'Empanadas de jaiba recién horneadas',
      category: 'Platos',
    },
    {
      id: 8,
      src: ambiente3,
      alt: 'Barra de cócteles y bebidas',
      category: 'Ambiente',
    },
  ];

  const [filter, setFilter] = useState('Todos');
  const categories = ['Todos', 'Platos', 'Ambiente'];

  const filteredImages = filter === 'Todos'
    ? galleryImages
    : galleryImages.filter(img => img.category === filter);

  const openModal = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className="py-20 bg-marina-50 relative">
      <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-white to-marina-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-marina-50"></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="section-title inline-block">Galería Visual</h2>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Explora la experiencia de La Barra Brava a través de nuestra selección de imágenes de platos, ambiente y más.
          </p>
        </motion.div>

        {/* Filter buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map((category, index) => (
            <motion.button
              key={category}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => setFilter(category)}
              className={`px-4 py-2 rounded-full transition-colors duration-300 ${
                filter === category
                  ? 'bg-marina-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-marina-100'
              }`}
            >
              {category}
            </motion.button>
          ))}
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredImages.map((image, index) => (
            <motion.div
              key={image.id}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative overflow-hidden rounded-lg aspect-square cursor-pointer"
              onClick={() => openModal(image)}
            >
              <img 
                src={image.src} 
                alt={image.alt} 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-marina-900/70 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="text-white text-sm bg-marina-700 px-2 py-1 rounded-md">
                    {image.category}
                  </span>
                  <h3 className="text-white font-medium mt-1">{image.alt}</h3>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Image Modal */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            onClick={closeModal}
          >
            <div 
              className="max-w-4xl max-h-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-white p-2 rounded-lg">
                <img 
                  src={selectedImage.src} 
                  alt={selectedImage.alt}
                  className="max-h-[80vh] w-auto mx-auto"
                />
                <div className="p-4">
                  <h3 className="font-bold">{selectedImage.alt}</h3>
                  <p className="text-sm text-gray-600">{selectedImage.category}</p>
                </div>
              </div>
              <button 
                onClick={closeModal}
                className="absolute -top-12 right-0 text-white text-3xl"
                aria-label="Cerrar"
              >
                &times;
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;